// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper-slide {
  aspect-ratio: 445.28/620.47;
}

.card {
  --hsl: var(--hue), var(--saturation), var(--lightness);
}
.card:nth-child(1) {
  --hue: 44;
  --saturation: 100%;
  --lightness: 27%;
}
.card:nth-child(2) {
  --hue: 81;
  --saturation: 23%;
  --lightness: 74%;
}
.card:nth-child(3) {
  --hue: 177;
  --saturation: 100%;
  --lightness: 70%;
}
.card:nth-child(4) {
  --hue: 222.69;
  --saturation: 100%;
  --lightness: 66.04%;
}
.card:nth-child(5) {
  --hue: 338.69;
  --saturation: 100%;
  --lightness: 48.04%;
}
.card:nth-child(6) {
  --hue: 222.69;
  --saturation: 100%;
  --lightness: 48.04%;
}

.card > * {
  border: 1px solid rgba(236, 239, 241, 0.2);
  border-radius: 15px;
}

.swiper-slide > * {
  border-radius: 16px;
  border: 1px solid rgba(236, 239, 241, 0.2);
}
.swiper-slide .demos-head {
  border: 1px solid rgba(236, 239, 241, 0.2);
  padding: 1rem;
  color: var(--text-color);
  font-weight: bold;
  letter-spacing: 1.6px;
  border-radius: 16px;
}

@media only screen and (min-width: 1200px) {
  .swiper-slide {
    width: 33.33%;
  }
  .swiper-slide > * {
    border-radius: 16px;
    border: 1px solid rgba(236, 239, 241, 0.2);
  }
  .overlay .card > * .cta {
    position: absolute;
    bottom: calc(2rem + 2px);
    left: calc(2rem + 1px);
    width: calc(100% - 4rem - 2px);
    height: 59px;
    border-radius: 16px;
    background-color: hsl(var(--hsl));
    box-shadow: 0 0 0 1px hsl(var(--hsl));
  }
}
:host ::ng-deep .swiper-pagination-bullet {
  width: 1rem;
  border-radius: 8px;
  background: white;
  height: 6px;
  transition: width 0.2s ease-in;
}

:host ::ng-deep .swiper-pagination-bullet-active {
  transition: width 0.2s ease-in;
  background: var(--primary-color);
  width: 5rem;
  border-radius: 8px;
  height: 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/home/components/demos/demos.component.scss"],"names":[],"mappings":"AAWA;EACE,2BAAA;AAVF;;AAaA;EAgCE,sDAAA;AAzCF;AAUE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;AARJ;AAUE;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;AARJ;AAUE;EACE,UAAA;EACA,kBAAA;EACA,gBAAA;AARJ;AAUE;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;AARJ;AAUE;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;AARJ;AAUE;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;AARJ;;AAcA;EACE,0CAAA;EACA,mBAAA;AAXF;;AAeE;EACE,mBAAA;EACA,0CAAA;AAZJ;AAeE;EACE,0CAAA;EACA,aAAA;EACA,wBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;AAbJ;;AAhDE;EAkEA;IACE,aAAA;EAdF;EAgBE;IACE,mBAAA;IACA,0CAAA;EAdJ;EAoBI;IACE,kBAAA;IACA,wBAAA;IACA,sBAAA;IACA,8BAAA;IACA,YAAA;IACA,mBAAA;IACA,iCAAA;IACA,qCAAA;EAlBN;AACF;AAuBA;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,8BAAA;AArBF;;AAwBA;EACE,8BAAA;EACA,gCAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AArBF","sourcesContent":["@mixin md() {\r\n  @media only screen and (max-width: 1199px) {\r\n    @content;\r\n  }\r\n}\r\n@mixin mu() {\r\n  @media only screen and (min-width: 1200px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n.swiper-slide {\r\n  aspect-ratio: 445.28 / 620.47;\r\n}\r\n\r\n.card {\r\n  &:nth-child(1) {\r\n    --hue: 44;\r\n    --saturation: 100%;\r\n    --lightness: 27%;\r\n  }\r\n  &:nth-child(2) {\r\n    --hue: 81;\r\n    --saturation: 23%;\r\n    --lightness: 74%;\r\n  }\r\n  &:nth-child(3) {\r\n    --hue: 177;\r\n    --saturation: 100%;\r\n    --lightness: 70%;\r\n  }\r\n  &:nth-child(4) {\r\n    --hue: 222.69;\r\n    --saturation: 100%;\r\n    --lightness: 66.04%;\r\n  }\r\n  &:nth-child(5) {\r\n    --hue: 338.69;\r\n    --saturation: 100%;\r\n    --lightness: 48.04%;\r\n  }\r\n  &:nth-child(6) {\r\n    --hue: 222.69;\r\n    --saturation: 100%;\r\n    --lightness: 48.04%;\r\n  }\r\n\r\n  --hsl: var(--hue), var(--saturation), var(--lightness);\r\n}\r\n\r\n.card > * {\r\n  border: 1px solid #eceff133;\r\n  border-radius: 15px;\r\n}\r\n\r\n.swiper-slide {\r\n  > * {\r\n    border-radius: 16px;\r\n    border: 1px solid #eceff133;\r\n  }\r\n\r\n  .demos-head {\r\n    border: 1px solid #eceff133;\r\n    padding: 1rem;\r\n    color: var(--text-color);\r\n    font-weight: bold;\r\n    letter-spacing: 1.6px;\r\n    border-radius: 16px;\r\n  }\r\n}\r\n\r\n@include mu() {\r\n  .swiper-slide {\r\n    width: 33.33%;\r\n\r\n    > * {\r\n      border-radius: 16px;\r\n      border: 1px solid #eceff133;\r\n    }\r\n  }\r\n\r\n  .overlay {\r\n    .card > * {\r\n      .cta {\r\n        position: absolute;\r\n        bottom: calc(2rem + 2px);\r\n        left: calc(2rem + 1px);\r\n        width: calc(100% - 4rem - 2px);\r\n        height: 59px;\r\n        border-radius: 16px;\r\n        background-color: hsl(var(--hsl));\r\n        box-shadow: 0 0 0 1px hsl(var(--hsl));\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n:host ::ng-deep .swiper-pagination-bullet {\r\n  width: 1rem;\r\n  border-radius: 8px;\r\n  background: white;\r\n  height: 6px;\r\n  transition: width 0.2s ease-in;\r\n}\r\n\r\n:host ::ng-deep .swiper-pagination-bullet-active {\r\n  transition: width 0.2s ease-in;\r\n  background: var(--primary-color);\r\n  width: 5rem;\r\n  border-radius: 8px;\r\n  height: 6px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
